const REPORT_NAME_MAX_LENGTH = 30;

const reportNameNormalize = (value, prevValue) => {
    if (value.length > REPORT_NAME_MAX_LENGTH) return prevValue;

    return value;
};

export default reportNameNormalize;
